module.exports = __webpack_public_path__ + "img/left_nav_bg2.835a12c1.png";